import React from 'react'
import UpgradeSubscription from 'src/app/UpgradeSubscription/UpgradeSubscription'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { upgradeSubscriptionRouteProps } from 'src/navigation/routeProps'

import { AppLocation } from '../appLocations'

const UpgradeSubscriptionAppRoute: AppRoute = {
  id: AppLocation.UpgradeSubscription,
  routeProps: upgradeSubscriptionRouteProps,
  component: <UpgradeSubscription />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default UpgradeSubscriptionAppRoute
